import { render, staticRenderFns } from "./AppDialog.vue?vue&type=template&id=24f6c474"
import script from "./AppDialog.vue?vue&type=script&lang=ts"
export * from "./AppDialog.vue?vue&type=script&lang=ts"
import style0 from "./AppDialog.vue?vue&type=style&index=0&id=24f6c474&prod&lang=scss"
import style1 from "./AppDialog.vue?vue&type=style&index=1&id=24f6c474&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default})
